const getYearSources = props => {
  const yearSources = {}
  const { entity, resourceType } = props
  const { cashflowData, fiscalYears } = entity
  for (const fiscalYear of fiscalYears) {
    const { year, period } = fiscalYear
    const dataForYear = cashflowData.filter(datum => datum.year === year)
    const hasTranscripts = dataForYear.some(datum => datum.source === 'tax_transcript')
    const hasManualTranscript = dataForYear.some(datum => datum.source === 'manual_transcript')
    const hasManualDocument = dataForYear.some(datum => datum.source === 'manual_document')
    const isAveraged = period === 'interim' && resourceType === 'Guarantor'
    let source
    if (hasTranscripts) {
      source = 'tax_transcript'
    } else if (isAveraged) {
      source = null
    } else if (hasManualTranscript) {
      source = 'manual_transcript'
    } else if (hasManualDocument) {
      source = 'manual_document'
    } else {
      source = 'manual_document'
    }
    yearSources[year] = { source, period }
  }
  return yearSources
}

export default getYearSources
